"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttGrid = _interopRequireDefault(require("../SttLayout/SttGrid"));
var _SttButton = _interopRequireDefault(require("../SttButton/SttButton"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _SttNotification = _interopRequireDefault(require("../SttSurfaces/SttNotification"));
var _daypilotLiteReact = require("@daypilot/daypilot-lite-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _excluded = ["value", "onEventDelete", "eventDeleteHandling", "onTimeRangeSelected", "initialDate", "calendarRef"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    divCalendario: {
      marginTop: theme.spacing(1)
    },
    divMes: {
      marginTop: '7px',
      display: 'flex',
      alignItems: 'center'
    },
    button: {
      marginLeft: theme.spacing(1)
    },
    textMes: {
      marginLeft: theme.spacing(1)
    },
    notification: {
      display: 'flex',
      flexDirection: 'column'
    },
    alert: {
      marginTop: theme.spacing(1)
    }
  };
});
var mesAtual = _daypilotLiteReact.DayPilot.Date.today().addHours(12);
var mesAnterior = _daypilotLiteReact.DayPilot.Date.today().addHours(12).addMonths(-1);
var mesSeguinte = _daypilotLiteReact.DayPilot.Date.today().addHours(12).addMonths(1);
var minHeight = 130;
var SttMonthCalendar = function SttMonthCalendar(props) {
  var value = props.value,
    onEventDelete = props.onEventDelete,
    _props$eventDeleteHan = props.eventDeleteHandling,
    eventDeleteHandling = _props$eventDeleteHan === void 0 ? 'Enabled' : _props$eventDeleteHan,
    onTimeRangeSelected = props.onTimeRangeSelected,
    _props$initialDate = props.initialDate,
    initialDate = _props$initialDate === void 0 ? mesAtual : _props$initialDate,
    calendarRef = props.calendarRef,
    others = _objectWithoutProperties(props, _excluded);
  var classes = useStyles();
  var _useState = (0, _react.useState)(initialDate),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = (0, _react.useState)(minHeight),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  (0, _react.useEffect)(function () {
    if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
      var dias = {};
      value.forEach(function (a) {
        var diaAtual = (0, _moment["default"])(a.data).format('YYYY-MM-DD');
        dias[diaAtual] = dias[diaAtual] ? ++dias[diaAtual] : 1;
      });
      var maxEventsDia = Object.values(dias).reduce(function (a, b) {
        return Math.max(a, b);
      }, -Infinity);
      if (maxEventsDia >= 4) {
        setHeight(minHeight + (maxEventsDia - 3) * 30);
      }
    }
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true,
    xs: 12,
    className: classes.divMes
  }, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "outlined",
    nomarginleft: "true",
    onClick: function onClick() {
      if (startDate === mesSeguinte) {
        setStartDate(mesAtual);
      } else {
        setStartDate(mesAnterior);
      }
    },
    disabled: startDate === mesAnterior,
    "aria-label": "M\xEAs anterior"
  }, "<"), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    color: "primary",
    className: classes.textMes
  }, startDate.toDate().toLocaleString('pt-br', {
    month: 'long',
    year: 'numeric'
  }).toUpperCase()), /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: function onClick() {
      if (startDate === mesAnterior) {
        setStartDate(mesAtual);
      } else {
        setStartDate(mesSeguinte);
      }
    },
    disabled: startDate === mesSeguinte,
    "aria-label": "Pr\xF3ximo m\xEAs"
  }, ">"))), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true,
    xs: 12,
    className: classes.divCalendario
  }, /*#__PURE__*/_react["default"].createElement(_daypilotLiteReact.DayPilotMonth, _extends({
    startDate: startDate,
    events: value,
    ref: calendarRef,
    eventHeight: 30,
    locale: 'pt-br',
    cellHeight: height,
    eventMoveHandling: 'Disabled',
    eventDeleteHandling: eventDeleteHandling,
    onEventDelete: onEventDelete,
    onTimeRangeSelected: onTimeRangeSelected
  }, others)))), /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_SttGrid["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_SttNotification["default"], {
    severity: "info",
    className: classes.alert
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.notification
  }, /*#__PURE__*/_react["default"].createElement("span", null, "- Para adicionar os dias de trabalho do(s) teleconsultor(es) na agenda \xE9 preciso ter registro na tabela \"Teleconsultores adicionados\";"), /*#__PURE__*/_react["default"].createElement("span", null, "- Em seguinda, \xE9 necess\xE1rio a sele\xE7\xE3o de ao menos um teleconsultor atrav\xE9s do ", /*#__PURE__*/_react["default"].createElement("i", null, "checkbox"), " da coluna \"selecionar\";"), /*#__PURE__*/_react["default"].createElement("span", null, "- Com isso, j\xE1 \xE9 poss\xEDvel clicar num dia espec\xEDfico ou selecionar m\xFAltiplos dias para adicionar o(s) registro(s) no calend\xE1rio;"), /*#__PURE__*/_react["default"].createElement("span", null, "- Para remover o(s) registro(s) do calend\xE1rio basta clicar no \"X\" que aparece ao lado do nome do teleconsultor quando se passa o mouse sobre a c\xE9lula;"))))));
};
SttMonthCalendar.propTypes = {
  value: _propTypes["default"].array.isRequired,
  calendarRef: _propTypes["default"].object.isRequired,
  eventDeleteHandling: _propTypes["default"].string,
  onTimeRangeSelected: _propTypes["default"].func,
  onEventDelete: _propTypes["default"].func,
  initialDate: _propTypes["default"].object
};
var _default = SttMonthCalendar;
exports["default"] = _default;